// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { ModuleLauncherMenuItem } from "./ModuleLauncherMenuItem";
import { ModuleLauncherMenuList } from "./ModuleLauncherMenuList";
import { ModuleDataProvider } from "./ModuleDataProvider";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ModuleLauncherMenu = props => {
  const {
    domain
  } = props;
  const getModulesItems = React.useCallback(modules => _.map(modules, ({
    // eslint-disable-next-line @typescript-eslint/no-shadow
    identifiant,
    code,
    libelle,
    adresse,
    modules,
    visible
  }) => /*#__PURE__*/_jsxs(_Fragment, {
    children: [visible && /*#__PURE__*/_jsx(ModuleLauncherMenuItem, {
      identifiant: identifiant,
      code: code,
      libelle: libelle,
      adresse: adresse
    }, identifiant), _.map(modules, mo => mo.visible && /*#__PURE__*/_jsx(ModuleLauncherMenuItem, {
      identifiant: mo.identifiant,
      code: mo.code,
      libelle: mo.libelle,
      adresse: mo.adresse,
      module: visible
    }, `${identifiant}-${mo.identifiant}`))]
  })), []);
  const renderModulesProvider = React.useCallback(modules => /*#__PURE__*/_jsx(ModuleLauncherMenuList, {
    items: getModulesItems(modules)
  }), [getModulesItems]);
  return React.useMemo(() => /*#__PURE__*/_jsx(ModuleDataProvider, {
    domain: domain,
    children: renderModulesProvider
  }), [domain, renderModulesProvider]);
};